"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APENFTQuery = void 0;
var queryAPI_1 = require("./restful/queryAPI");
var graphql_1 = require("./graphql");
var constants_1 = require("../utils/constants");
var utils_1 = require("../utils/utils");
var types_1 = require("../utils/types");
var APENFTQuery = /** @class */ (function (_super) {
    __extends(APENFTQuery, _super);
    // init SDK
    function APENFTQuery(walletProvider, apiConfig, walletAccount) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, apiConfig) || this;
        _this.accountAddress = "";
        var networkName = apiConfig.networkName;
        _this.accountAddress =
            (walletAccount === null || walletAccount === void 0 ? void 0 : walletAccount.address) || ((_a = walletProvider.defaultAddress) === null || _a === void 0 ? void 0 : _a.base58) || "";
        if (((_b = _this.accountAddress) === null || _b === void 0 ? void 0 : _b.length) > 0)
            _this.accountAddress;
        _this.gqlApi = {
            collectionApi: new graphql_1.GqlApi.collectionApi({
                networkName: networkName,
                account: _this.accountAddress,
            }),
            assetApi: new graphql_1.GqlApi.assetApi({
                networkName: networkName,
                account: _this.accountAddress,
            }),
            accountApi: new graphql_1.GqlApi.accountApi({
                networkName: networkName,
                account: _this.accountAddress,
            }),
        };
        _this.walletProvider = walletProvider;
        return _this;
    }
    APENFTQuery.prototype.getSingleCollectionInfo = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var singleCollectionInfoParams, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        singleCollectionInfoParams = {
                            address: address,
                        };
                        return [4 /*yield*/, this.gqlApi.collectionApi.getSingleCollectionInfo(singleCollectionInfoParams)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.collection];
                }
            });
        });
    };
    APENFTQuery.prototype.getCollectionTradeTrend = function (_a) {
        var _b = _a.days, days = _b === void 0 ? types_1.CollectionTradeTrendFilterDays.Days_90 : _b, collection = _a.collection;
        return __awaiter(this, void 0, void 0, function () {
            var collectionTradeTrendParams;
            return __generator(this, function (_c) {
                collectionTradeTrendParams = {
                    days: days,
                    collection: collection,
                };
                return [2 /*return*/, this.gqlApi.collectionApi.getCollectionTradeTrend(collectionTradeTrendParams)];
            });
        });
    };
    APENFTQuery.prototype.getSingleCollectionAttributes = function (_a) {
        var address = _a.address;
        return __awaiter(this, void 0, void 0, function () {
            var singleCollectionInfoParams;
            return __generator(this, function (_b) {
                singleCollectionInfoParams = {
                    address: address,
                };
                return [2 /*return*/, this.gqlApi.collectionApi.getSingleCollectionAttributes(singleCollectionInfoParams)];
            });
        });
    };
    APENFTQuery.prototype.getCollectionTradingHistory = function (_a) {
        var _b = _a.pagination, pagination = _b === void 0 ? { first: 100 } : _b, event_types = _a.event_types, currencies = _a.currencies, collections = _a.collections, user = _a.user;
        return __awaiter(this, void 0, void 0, function () {
            var collectionTradingHistoryParams;
            return __generator(this, function (_c) {
                collectionTradingHistoryParams = {
                    pagination: pagination,
                    event_types: event_types,
                    currencies: currencies,
                    collections: collections,
                    user: user,
                };
                return [2 /*return*/, this.gqlApi.collectionApi.getCollectionTradingHistory(collectionTradingHistoryParams)];
            });
        });
    };
    APENFTQuery.prototype.getHotCollections = function (_a) {
        var chain = _a.chain, is_recommend = _a.is_recommend;
        return __awaiter(this, void 0, void 0, function () {
            var hotCollectionsParams;
            return __generator(this, function (_b) {
                hotCollectionsParams = {
                    chain: chain,
                    is_recommend: is_recommend,
                };
                return [2 /*return*/, this.gqlApi.collectionApi.getHotCollections(hotCollectionsParams)];
            });
        });
    };
    APENFTQuery.prototype.getAssetListingOrders = function (collection, id, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var assetListingsParams, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assetListingsParams = {
                            pagination: {
                                first: (pagination === null || pagination === void 0 ? void 0 : pagination.first) || 100,
                                cursor: (pagination === null || pagination === void 0 ? void 0 : pagination.cursor) || "",
                            },
                            is_order_ask: true,
                            token_id: id,
                            collection: collection,
                        };
                        return [4 /*yield*/, this.gqlApi.assetApi.getAssetListings(assetListingsParams)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.nft_valid_orders];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetOffers = function (collection, id, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var assetOffersParams, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assetOffersParams = {
                            pagination: {
                                first: (pagination === null || pagination === void 0 ? void 0 : pagination.first) || 100,
                                cursor: (pagination === null || pagination === void 0 ? void 0 : pagination.cursor) || "",
                            },
                            is_order_ask: false,
                            token_id: id,
                            collection: collection,
                        };
                        return [4 /*yield*/, this.gqlApi.assetApi.getAssetOffers(assetOffersParams)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.nft_valid_orders];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetDetail = function (collection, id) {
        return __awaiter(this, void 0, void 0, function () {
            var assetDetailParams, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assetDetailParams = {
                            token_id: id,
                            collection: collection,
                        };
                        return [4 /*yield*/, this.gqlApi.assetApi.getAssetDetail(assetDetailParams)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.asset];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetTradingHistory = function (collection, id, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var assetTradingHistoryParams, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assetTradingHistoryParams = {
                            collections: [collection],
                            token_id: id,
                            pagination: {
                                first: (pagination === null || pagination === void 0 ? void 0 : pagination.first) || 100,
                                cursor: (pagination === null || pagination === void 0 ? void 0 : pagination.cursor) || "",
                            },
                        };
                        return [4 /*yield*/, this.gqlApi.assetApi.getAssetTradingHistory(assetTradingHistoryParams)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.events];
                }
            });
        });
    };
    APENFTQuery.prototype.getCollectionAssetsList = function (collection, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var assetMoreParams, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assetMoreParams = {
                            pagination: {
                                first: (pagination === null || pagination === void 0 ? void 0 : pagination.first) || 100,
                                cursor: (pagination === null || pagination === void 0 ? void 0 : pagination.cursor) || "",
                            },
                            sort: types_1.AssetSortBy.RecentlyCreated,
                            collections: [collection],
                        };
                        return [4 /*yield*/, this.gqlApi.assetApi.getAssetMoreCollection(assetMoreParams)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.assets];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetBestAskOrderInfo = function (collection, id) {
        return __awaiter(this, void 0, void 0, function () {
            var data, assetListingInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetListings(collection, id)];
                    case 1:
                        data = _a.sent();
                        assetListingInfo = data[0];
                        if (assetListingInfo === null || assetListingInfo === void 0 ? void 0 : assetListingInfo.bestAskOrderString) {
                            return [2 /*return*/, JSON.parse(assetListingInfo.bestAskOrderString)];
                        }
                        else {
                            return [2 /*return*/, {}];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetBidInfo = function (collection, id) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetBids(collection, id)];
                    case 1:
                        data = _a.sent();
                        if (data === null || data === void 0 ? void 0 : data.length) {
                            return [2 /*return*/, data[0]];
                        }
                        else {
                            return [2 /*return*/, {}];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetBidOrderParams = function (collection, id, price, currencyUnit) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function () {
            var assetData, bidData, askData, currency, paymentTokens, paymentToken, params;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0: return [4 /*yield*/, this.getAssetDetail(collection, id)];
                    case 1:
                        assetData = _h.sent();
                        bidData = (_a = assetData === null || assetData === void 0 ? void 0 : assetData.bids_v2) === null || _a === void 0 ? void 0 : _a[0];
                        askData = (_b = assetData === null || assetData === void 0 ? void 0 : assetData.asks_v2) === null || _b === void 0 ? void 0 : _b[0];
                        currency = ((_c = bidData === null || bidData === void 0 ? void 0 : bidData.currency) === null || _c === void 0 ? void 0 : _c.symbol)
                            ? (_d = bidData === null || bidData === void 0 ? void 0 : bidData.currency) === null || _d === void 0 ? void 0 : _d.symbol
                            : (_e = askData === null || askData === void 0 ? void 0 : askData.currency) === null || _e === void 0 ? void 0 : _e.symbol;
                        paymentTokens = (_g = (_f = assetData === null || assetData === void 0 ? void 0 : assetData.collection) === null || _f === void 0 ? void 0 : _f.payment_tokens) === null || _g === void 0 ? void 0 : _g.filter(function (val) {
                            return val.symbol === currency;
                        });
                        currencyUnit = currencyUnit || currency;
                        price = price || (askData === null || askData === void 0 ? void 0 : askData.bestAskPrice);
                        paymentToken = paymentTokens === null || paymentTokens === void 0 ? void 0 : paymentTokens.find(function (val) { return val.symbol.toLowerCase() === (currencyUnit === null || currencyUnit === void 0 ? void 0 : currencyUnit.toLowerCase()); });
                        params = {
                            asset: this.getAssetFormatData(assetData),
                            quantity: 1,
                            paymentToken: paymentToken,
                            startAmount: price,
                            bestAsk: askData,
                            expirationTime: askData === null || askData === void 0 ? void 0 : askData.bestAskExpirationDate,
                        };
                        return [2 /*return*/, params];
                }
            });
        });
    };
    APENFTQuery.prototype.getEnglishAuctionOrderParams = function (_a) {
        var _b, _c;
        var collection = _a.collection, id = _a.id, bidPrice = _a.bidPrice, reservePrice = _a.reservePrice, currency = _a.currency, expirationTime = _a.expirationTime;
        return __awaiter(this, void 0, void 0, function () {
            var assetData, paymentToken, params;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getAssetDetail(collection, id)];
                    case 1:
                        assetData = _d.sent();
                        paymentToken = (_c = (_b = assetData === null || assetData === void 0 ? void 0 : assetData.collection) === null || _b === void 0 ? void 0 : _b.payment_tokens) === null || _c === void 0 ? void 0 : _c.find(function (val) { return val.symbol.toLowerCase() === currency.toLowerCase(); });
                        expirationTime = Math.round(expirationTime / 1000);
                        params = {
                            asset: this.getAssetFormatData(assetData),
                            quantity: 1,
                            paymentToken: __assign(__assign({}, paymentToken), { decimals: paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.decimal }),
                            englishAuctionReservePrice: reservePrice,
                            expirationTime: expirationTime,
                            startAmount: bidPrice,
                        };
                        return [2 /*return*/, params];
                }
            });
        });
    };
    APENFTQuery.prototype.getFixPriceOrderParams = function (_a) {
        var _b, _c;
        var collection = _a.collection, id = _a.id, price = _a.price, currency = _a.currency, expirationTime = _a.expirationTime, buyerAddress = _a.buyerAddress;
        return __awaiter(this, void 0, void 0, function () {
            var assetData, paymentToken, listingTime, params;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getAssetDetail(collection, id)];
                    case 1:
                        assetData = _d.sent();
                        paymentToken = (_c = (_b = assetData === null || assetData === void 0 ? void 0 : assetData.collection) === null || _b === void 0 ? void 0 : _b.payment_tokens) === null || _c === void 0 ? void 0 : _c.find(function (val) { return val.symbol.toLowerCase() === currency.toLowerCase(); });
                        expirationTime = Math.round(expirationTime / 1000);
                        listingTime = Math.round(Date.now() / 1000 + 5);
                        params = {
                            asset: this.getAssetFormatData(assetData, buyerAddress),
                            quantity: 1,
                            paymentToken: __assign(__assign({}, paymentToken), { decimals: paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.decimal }),
                            expirationTime: expirationTime,
                            startAmount: price,
                            listingTime: listingTime,
                            buyerAddress: buyerAddress,
                        };
                        return [2 /*return*/, params];
                }
            });
        });
    };
    APENFTQuery.prototype.getEnglishAuctionBiddingOrderParams = function (_a) {
        var _b, _c, _d;
        var collection = _a.collection, id = _a.id, price = _a.price, currency = _a.currency;
        return __awaiter(this, void 0, void 0, function () {
            var assetData, askData, paymentToken, params;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.getAssetDetail(collection, id)];
                    case 1:
                        assetData = _e.sent();
                        askData = (_b = assetData === null || assetData === void 0 ? void 0 : assetData.asks_v2) === null || _b === void 0 ? void 0 : _b[0];
                        paymentToken = (_d = (_c = assetData === null || assetData === void 0 ? void 0 : assetData.collection) === null || _c === void 0 ? void 0 : _c.payment_tokens) === null || _d === void 0 ? void 0 : _d.find(function (val) { return val.symbol.toLowerCase() === currency.toLowerCase(); });
                        params = {
                            asset: this.getAssetFormatData(assetData),
                            quantity: 1,
                            bestAsk: askData,
                            paymentToken: __assign(__assign({}, paymentToken), { decimals: paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.decimal }),
                            startAmount: price,
                        };
                        return [2 /*return*/, params];
                }
            });
        });
    };
    APENFTQuery.prototype.getLowerPriceOrderParams = function (_a) {
        var _b, _c;
        var collection = _a.collection, id = _a.id, price = _a.price;
        return __awaiter(this, void 0, void 0, function () {
            var assetData, askData, decimal, oldOrder, params;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getAssetDetail(collection, id)];
                    case 1:
                        assetData = _d.sent();
                        askData = (_b = assetData === null || assetData === void 0 ? void 0 : assetData.asks_v2) === null || _b === void 0 ? void 0 : _b[0];
                        decimal = (_c = askData === null || askData === void 0 ? void 0 : askData.currency) === null || _c === void 0 ? void 0 : _c.decimal;
                        oldOrder = JSON.parse(askData === null || askData === void 0 ? void 0 : askData.bestAskOrderString);
                        params = {
                            asset: this.getAssetFormatData(assetData),
                            oldOrder: oldOrder,
                            parameter: {
                                quantity: "1",
                                basePrice: (0, utils_1.withPrecision)(price, decimal),
                            },
                        };
                        return [2 /*return*/, params];
                }
            });
        });
    };
    APENFTQuery.prototype.getMakeOfferOrderOrderParams = function (_a) {
        var collection = _a.collection, id = _a.id, price = _a.price, currency = _a.currency, expirationTime = _a.expirationTime;
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_b) {
                params = {
                    collection: collection,
                    id: id,
                    price: price,
                    currency: currency,
                    expirationTime: expirationTime,
                };
                return [2 /*return*/, this.getFixPriceOrderParams(params)];
            });
        });
    };
    APENFTQuery.prototype.getTransferParams = function (collection, id) {
        return __awaiter(this, void 0, void 0, function () {
            var asset, metadata, assetData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetDetail(collection, id)];
                    case 1:
                        asset = _a.sent();
                        metadata = {
                            asset: {
                                id: asset === null || asset === void 0 ? void 0 : asset.token_id,
                                address: asset === null || asset === void 0 ? void 0 : asset.contract_address,
                                quantity: 1,
                                data: "",
                            },
                            schema: constants_1.TOKEN_TYPE_MAP[asset === null || asset === void 0 ? void 0 : asset.token_type],
                        };
                        assetData = {
                            tokenId: asset === null || asset === void 0 ? void 0 : asset.token_id,
                            tokenAddress: asset === null || asset === void 0 ? void 0 : asset.contract_address,
                        };
                        return [2 /*return*/, { metadata: metadata, assetData: assetData }];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetFormatData = function (assetData, buyerAddress) {
        var _a, _b;
        var asset = {
            tokenId: assetData.token_id,
            tokenAddress: assetData.contract_address,
            schemaName: constants_1.TOKEN_TYPE_MAP[assetData === null || assetData === void 0 ? void 0 : assetData.token_type],
            data: assetData === null || assetData === void 0 ? void 0 : assetData.token_uri,
            collection: {
                transferFeeAddress: buyerAddress
                    ? ""
                    : (_a = assetData === null || assetData === void 0 ? void 0 : assetData.collection) === null || _a === void 0 ? void 0 : _a.royalty_address,
                elementSellerFeeBasisPoints: buyerAddress
                    ? 0
                    : ((_b = assetData === null || assetData === void 0 ? void 0 : assetData.collection) === null || _b === void 0 ? void 0 : _b.royalty) || 0,
            },
        };
        return asset;
    };
    APENFTQuery.prototype.getAssetSaleInfo = function (collection, id) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssetSales(collection, id)];
                    case 1:
                        data = _a.sent();
                        if (data === null || data === void 0 ? void 0 : data.length) {
                            return [2 /*return*/, data[0]];
                        }
                        else {
                            return [2 /*return*/, {}];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetSales = function (collection, id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var assetDetailParams, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        assetDetailParams = {
                            token_id: id,
                            collection: collection,
                        };
                        return [4 /*yield*/, this.gqlApi.assetApi.getAssetSales(assetDetailParams)];
                    case 1:
                        data = _b.sent();
                        return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.asset) === null || _a === void 0 ? void 0 : _a.sales_v2];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetBids = function (collection, id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var assetDetailParams, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        assetDetailParams = {
                            token_id: id,
                            collection: collection,
                        };
                        return [4 /*yield*/, this.gqlApi.assetApi.getAssetBids(assetDetailParams)];
                    case 1:
                        data = _b.sent();
                        return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.asset) === null || _a === void 0 ? void 0 : _a.bids_v2];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetListings = function (collection, id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var assetDetailParams, assetListingInfo, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        assetDetailParams = {
                            token_id: id,
                            collection: collection,
                        };
                        return [4 /*yield*/, this.gqlApi.assetApi.getAssetListingInfo(assetDetailParams)];
                    case 1:
                        assetListingInfo = _b.sent();
                        data = (_a = assetListingInfo === null || assetListingInfo === void 0 ? void 0 : assetListingInfo.asset) === null || _a === void 0 ? void 0 : _a.asks_v2;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    APENFTQuery.prototype.getAssetsList = function (account, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var userAssetParams, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userAssetParams = {
                            pagination: {
                                first: (pagination === null || pagination === void 0 ? void 0 : pagination.first) || 100,
                                cursor: (pagination === null || pagination === void 0 ? void 0 : pagination.cursor) || "",
                            },
                            user: account,
                            sort: types_1.AssetSortBy.RecentlyListed,
                            owners: [account],
                        };
                        return [4 /*yield*/, this.gqlApi.accountApi.getAssets(userAssetParams)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.assets];
                }
            });
        });
    };
    APENFTQuery.prototype.getSentOffers = function (account, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var userAssetOffersParams, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userAssetOffersParams = {
                            pagination: {
                                first: (pagination === null || pagination === void 0 ? void 0 : pagination.first) || 100,
                                cursor: (pagination === null || pagination === void 0 ? void 0 : pagination.cursor) || "",
                            },
                            user: account,
                        };
                        return [4 /*yield*/, this.gqlApi.accountApi.getUserSentOffers(userAssetOffersParams)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.user_sent_offers];
                }
            });
        });
    };
    APENFTQuery.prototype.getReceivedOffers = function (account, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var userAssetOffersParams, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userAssetOffersParams = {
                            pagination: {
                                first: (pagination === null || pagination === void 0 ? void 0 : pagination.first) || 100,
                                cursor: (pagination === null || pagination === void 0 ? void 0 : pagination.cursor) || "",
                            },
                            user: account,
                        };
                        return [4 /*yield*/, this.gqlApi.accountApi.getUserReceivedOffers(userAssetOffersParams)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.user_rcvd_offers];
                }
            });
        });
    };
    APENFTQuery.prototype.getCollections = function (account, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            pagination: {
                                first: (pagination === null || pagination === void 0 ? void 0 : pagination.first) || 100,
                                cursor: (pagination === null || pagination === void 0 ? void 0 : pagination.cursor) || "",
                            },
                            owners: [account],
                        };
                        return [4 /*yield*/, this.gqlApi.accountApi.getCollections(params)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.collections];
                }
            });
        });
    };
    return APENFTQuery;
}(queryAPI_1.QueryAPI));
exports.APENFTQuery = APENFTQuery;
